import { Link } from 'react-router-dom';
import type { ComicItem } from '@/mocks/types';

interface ComicCardProps {
  comic: ComicItem;
  size?: 'small' | 'medium' | 'large';
}

export default function ComicCard({ comic, size = 'medium' }: ComicCardProps) {
  const sizeClasses = {
    small: 'w-[140px] md:w-[160px]',
    medium: 'w-[160px] md:w-[180px]',
    large: 'w-[180px] md:w-[200px]',
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className={`${sizeClasses[size]} group cursor-pointer flex-shrink-0`}
      data-product-shop
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-2 bg-background-200">
        <img
          src={comic.coverUrl}
          alt={`${comic.title} - 韩国漫画`}
          title={`${comic.title} - 韩国漫画在线免费阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-3">
          <span className="text-white text-xs font-medium bg-primary-500/90 px-3 py-1 rounded-full whitespace-nowrap">
            立即阅读
          </span>
        </div>
        {comic.isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-white text-[10px] font-semibold px-2 py-0.5 rounded-full whitespace-nowrap">
            NEW
          </span>
        )}
        {comic.isHot && (
          <span className="absolute top-2 right-2 bg-primary-500 text-white text-[10px] font-semibold px-2 py-0.5 rounded-full whitespace-nowrap">
            HOT
          </span>
        )}
        <span className="absolute bottom-2 left-2 bg-black/60 text-white text-[10px] font-medium px-1.5 py-0.5 rounded whitespace-nowrap">
          {comic.status}
        </span>
      </div>
      <h3 className="text-sm font-medium text-foreground-800 line-clamp-1 group-hover:text-primary-600 transition-colors">
        {comic.title}
      </h3>
      <div className="flex items-center justify-between mt-1">
        <span className="text-xs text-foreground-500 whitespace-nowrap">{comic.author}</span>
        <span className="flex items-center gap-0.5 text-xs text-accent-500 whitespace-nowrap">
          <i className="ri-star-fill text-[10px]"></i>
          {comic.rating}
        </span>
      </div>
    </Link>
  );
}